const RecipeType = {
  ASIAN: 1,
  WESTERN: 2,
  BAKERY: 3
};

export { RecipeType };
